import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import Box from '../../elements/Box';
import Row from '../../elements/Row';
import Col from '../../elements/Col';
import Icon from '../../elements/Icon';

const NextDestinationAlert = (props) => {
  const { row, messageStyles, iconStyles } = props;
  const { direction, translate, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Row {...row}>
      <Col textAlign="center">
        <Box paddingHeight="5" className={className} style={style} role="alert">
          <Box marginBottom="4" {...messageStyles}>
            {translate('cmp-location-selector-select-info', 'Find your next destination')}
          </Box>
          <Box>
            <Icon icon="travel" size={32} {...iconStyles} />
          </Box>
        </Box>
      </Col>
    </Row>
  );
};
NextDestinationAlert.propTypes = {
  row: PropTypes.objectOf(PropTypes.any),
  messageStyles: PropTypes.objectOf(PropTypes.any),
  iconStyles: PropTypes.objectOf(PropTypes.any),
};

NextDestinationAlert.defaultProps = {
  row: {},
  messageStyles: {},
  iconStyles: {},
};

NextDestinationAlert.componentName = 'NextDestinationAlert';
export default NextDestinationAlert;
